import { useMemo } from "react";

import { CenterLayout, ResultBlocker } from "@/components";

import { useAllowedPowerBiDashboards } from "../services/useAllowedPowerBiDashboards";

import { DashboardPowerBi } from "./DashboardPowerBi";

type DashboardPowerBiByCodeProps = {
  code: string;
};

export const DashboardPowerBiByCode = ({ code }: DashboardPowerBiByCodeProps) => {
  const { data: dashboards, isFetching } = useAllowedPowerBiDashboards();

  const dashboard = useMemo(() => {
    const codeLower = code.toLocaleLowerCase();
    return dashboards.find((dashboard) => dashboard.code.toLocaleLowerCase() === codeLower);
  }, [code, dashboards]);

  if (isFetching) {
    return <CenterLayout>Cargando...</CenterLayout>;
  }

  if (!dashboard) {
    return (
      <CenterLayout>
        <ResultBlocker status="notFound" />
      </CenterLayout>
    );
  }

  return <DashboardPowerBi dashboard={dashboard} />;
};
